import {
    BulkAction,
    DataService,
    ItemOf,
    ModalService,
    NotificationService,
    Permission,
} from '@vendure/admin-ui/core';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeleteContactsDocument, GetAllContactsQuery } from '../../generated-types';

export const deleteContactBulkAction: BulkAction<ItemOf<GetAllContactsQuery, 'contacts'>> = {
    location: 'affiliate-list',
    label: 'Delete',
    icon: 'trash',
    iconClass: 'text-danger',
    requiresPermission: Permission.SuperAdmin,
    onClick: ({ injector, selection, clearSelection, hostComponent }) => {
        const modalService = injector.get(ModalService);
        const dataService = injector.get(DataService);
        const notificationService = injector.get(NotificationService);

        const contactNames = selection.map(contact => contact.fullName ?? '').join(', ');

        modalService
            .dialog({
                title: 'Confirm Delete Contacts',
                body: `Are you sure you want to delete these Contacts (${contactNames})?`,
                buttons: [
                    { type: 'secondary', label: 'Cancel' },
                    { type: 'danger', label: 'Delete', returnValue: true },
                ],
            })
            .pipe(
                switchMap(response =>
                    response
                        ? dataService.mutate(DeleteContactsDocument, {
                              input: selection.map(f => f.id),
                          })
                        : EMPTY,
                ),
            )
            .subscribe({
                next: res => {
                    if (res.deleteContacts?.result === 'DELETED') {
                        notificationService.success('All selected Contacts deleted successfully.');
                    } else {
                        notificationService.error(
                            res.deleteContacts?.message || 'Failed to delete Contacts.',
                        );
                    }
                    clearSelection();
                    hostComponent?.refresh?.();
                },
                error: () => {
                    notificationService.error('An unexpected error occurred while deleting Contacts.');
                    clearSelection();
                },
            });
    },
};
